import React, { memo } from 'react';
import * as styles from './styles.pc';
import { Filters } from './Filters';
import { CompanyList } from './CompanyList';
import { Scrollable } from '@hum/ui-library';

export type AdminLeftSidebarProps = {
  currentCompanyUuid: string;
};

export const AdminLeftSidebar = memo(
  ({ currentCompanyUuid }: AdminLeftSidebarProps) => {
    return (
      <styles.Container>
        <Filters />
        <Scrollable>
          <CompanyList currentCompanyUuid={currentCompanyUuid} />
        </Scrollable>
      </styles.Container>
    );
  }
);
